<template>
  <div class="footer-common">
    <div class="flexStart">
      <ul style="margin-right:30px;">
        <li class="pointer">关于中国通用技术集团-中心采购平台</li>
        <li class="pointer">公司介绍</li>
        <li class="pointer">诚聘英才</li>
      </ul>
      <ul>
        <li class="pointer">联系我们</li>
        <li>客服电话：010-87483355(周一至周五9:00-17:00)</li>
        <li>合作电话：010-87483355</li>
        <li>地址：北京市朝阳区望京保利国际T2座14层</li>
      </ul>
    </div>
    <div class="footer-bar"><span style="margin-right:20px;">中国通用技术集团-中心采购平台科技有限公司</span>Copyright@2023 南阳商祺数贸科技有限公司 电话:400-0377-900
      </br>版权所有豫ICP备2023000680号-2 豫ICP证B2-20231049号</div>
  </div>
</template>

<script>
export default {
  name: "footerCommon",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped>
  .footer-common{
    background: #fff;
    padding-top:20px;
  }
  li{
    line-height: 28px;
  }
  .pointer:hover{
    color: #1e88f5;
  }
  .footer-bar{
    font-size: 12px;
    line-height: 35px;
    color: #666;
    text-align: center;
    border-top:1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components-frame/footer.vue